
import store from '@/store/index'
import Vue from 'vue'
import { MatchRequest, ProfileHistory } from '@chainsight/networker-backend-axios-sdk';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Viewer } from '@toast-ui/vue-editor';
import { format } from 'date-fns'
import { set } from 'vue/types/umd';
import { ca, de, hi, tr, vi } from 'date-fns/locale';

export default Vue.extend({
	name: 'BusinessMatchHistory',
	components: {
		viewer: Viewer
	},
	data() {
		return {
			overlay: false,
			restoreDialog: false,
			groupOption: true,
			snackbar: false,
			snackbarText: '',
			snackbarColor: '',
			currentVersionId: '',
			selectedHistoryId: '' as string | undefined,
			historyId: '' as string | undefined,
			profileMarkdown: '' as string | undefined,
			matchRequest: {} as MatchRequest,
			profileHistories: [] as ProfileHistory[],
			yearMonthGroup: [] as { 
				key: string;
				profileHistory: ProfileHistory[] 
			}[],
		};
	},
	computed: {
		trackDto(){
			return store.state.track.trackDto
		},
		user() {
			return store.state.user;
		}
	},
	methods: {
		scrollToTop() {
			window.scrollTo({
				top: 0,         // 滾動到頂部
				behavior: 'smooth' // 平滑滾動效果
			});
		},
		async getMatchRequest(){
			try {
				let getMatchRequestResp
				getMatchRequestResp = await this.api$.businessMatchApi.getMatchRequest(this.user.userDto?.id as string, this.trackDto?.id? this.trackDto.id : '0')
				this.matchRequest = getMatchRequestResp.data.data
			}catch (error) {
				console.error(error);
			}
		},
		async getProfileHistories(){
			this.yearMonthGroup = []
			let getProfileHistoriesResp
			try{
				getProfileHistoriesResp = await this.api$.businessMatchApi.getProfileHistory(this.user.userDto?.id as string, this.trackDto?.id? this.trackDto.id : '0')
				this.profileHistories = getProfileHistoriesResp.data.data
				this.profileMarkdown = this.profileHistories[0].profileMarkdown as string
				this.selectedHistoryId = this.profileHistories[0].id as string

				this.currentVersionId = this.profileHistories[0].id as string

				this.profileHistories.forEach((history) => {
					const date = new Date(history.createdAt as string)
					const yearMonth = `${date.getFullYear()} ${date.toLocaleString('en-US', { month: 'long' })}`

					if (!this.yearMonthGroup.find((item) => item.key === yearMonth)) {
						this.yearMonthGroup.push({ key: yearMonth, profileHistory: [] })
					}

					history.createdAt = format(new Date(history.createdAt as string), 'MMMM d, hh:mm a')
					this.yearMonthGroup.find((item) => item.key === yearMonth)?.profileHistory.push(history)
				})
			}catch (error) {
				console.error(error)
			}
		},
		async restore(profileHistoryId){
			this.overlay = true
			this.restoreDialog = false
			let restoreProfileHistoryResp
			try {
				restoreProfileHistoryResp = await this.api$.businessMatchApi.restoreProfileHistory(this.user.userDto?.id as string, profileHistoryId, this.trackDto?.id? this.trackDto.id : '0')
				this.matchRequest = restoreProfileHistoryResp.data.data
				await this.getProfileHistories()
				this.snackbar = true
				this.snackbarText = 'Your personal profile has been restored'
				this.snackbarColor = 'black'
			} catch (error) {
				console.error(error);
			}
			this.historyId = ''
			this.overlay = false
		}
	},
	async created() {
		this.overlay = true
		await this.getMatchRequest()
		await this.getProfileHistories()
		this.overlay = false
	}
});
